import React from 'react';

import classes from './Footer.css';

const Footer = () => {
	return (
         <footer role="contentinfo">
             <p><span></span> Created by Sarah </p>
         </footer>
	)
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js